import React from "react";

const WarningIcon = ({ width = 54, height = 52 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 54 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M291.771 6.25H276.229L265.25 17.2292V32.7708L276.229 43.75H291.771L302.75 32.7708V17.2292L291.771 6.25ZM298.583 31.0417L290.042 39.5833H277.958L269.417 31.0417V18.9583L277.958 10.4167H290.042L298.583 18.9583V31.0417Z"
      fill="#B36E00"
      transform="translate(-252 -4)"
    />
    <path
      d="M284 35.4167C285.151 35.4167 286.083 34.4839 286.083 33.3333C286.083 32.1827 285.151 31.25 284 31.25C282.849 31.25 281.917 32.1827 281.917 33.3333C281.917 34.4839 282.849 35.4167 284 35.4167Z"
      fill="#B36E00"
      transform="translate(-252 -4)"
    />
    <path
      d="M281.917 14.5833H286.083V29.1667H281.917V14.5833Z"
      fill="#B36E00"
      transform="translate(-252 -4)"
    />
  </svg>
);

export default WarningIcon;

